// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"313":"ca9fe7cc3576d87e","425":"88b034b058c4d0fe","436":"a0250dc3d575a725","525":"d3bc6520c9556340","752":"7820609873442f92","954":"83fea72389e5208a","961":"b1ad478425312e37","974":"709f4ae73baea18e"}[chunkId] + ".js";
};